import React, { useContext } from "react";
import PrivatePage from "../../components/PrivatePage";
import { AccountContext } from "../../providers/accountProvider";
import AnalyticsContainer from "./Analytics.container";
import AnalyticsUI from "./Analytics.UI";
import ComingSoon from "../ComingSoon"

const Analytics = (props) => {
    const { user } = useContext(AccountContext)
    return(
        <PrivatePage>
            <AnalyticsContainer {...props}>
               {user?.analytics ? <AnalyticsUI /> : <ComingSoon />}
            </AnalyticsContainer>
        </PrivatePage>
    )
}

export default Analytics;